import useAuthUser from "../../../common/hooks/authUser";

const DEALER_ACCESS_REQUEST_BASE_URL =
	"https://app.smartsheet.com/b/form/01a03453b0b7737c9b4303c705b51dce";

const DealerSetupWarning = () => {
	const { user, isAdmin, isDealer } = useAuthUser();

	if (isAdmin || isDealer) {
		return null;
	}

	const accessRequestUrl = user?.email
		? `${DEALER_ACCESS_REQUEST_BASE_URL}?Email=${encodeURIComponent(user.email)}`
		: DEALER_ACCESS_REQUEST_BASE_URL;

	return (
		<div className="mt-4 p-3 rounded border border-warning bg-warning-subtle">
			<h4 className="fw-bold mb-2 text-danger text-center">
				<i className="fas fa-exclamation-triangle me-2" aria-hidden="true" />
				Dealers
				<i className="fas fa-exclamation-triangle ms-2" aria-hidden="true" />
			</h4>
			<p className="mb-0">
				Dealer setup is required before you can register on behalf of an end user. If you have not been set up as a dealer and received setup instructions, please{" "}
				<a href={accessRequestUrl} target="_blank" rel="noopener noreferrer">
					submit an access request
				</a>
				.
			</p>
		</div>
	);
};

export default DealerSetupWarning;
